<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-space-around wrap>
      <v-flex md12>
        <v-toolbar color="primary" dark dense>
          <v-toolbar-title>Images</v-toolbar-title>
        </v-toolbar>
      </v-flex>

      <v-flex md12>
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <NewImage ref="NewImage" />
          </v-card-actions>
        </v-card>
      </v-flex>
      
      <v-flex md12>
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :footer-props="{
              'items-per-page-options': [25, 50, -1]
            }"
            :items="Object.values(allImages)"
            :loading="isLoading.images"
            :search="search"
            :sort-by="'lastmodified'"
            :sort-desc="true"
            item-key="imageid"
            class="elevation-1"
            dense
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.imageid" @click="openImageTab(item.imageid)" :style="{cursor:'pointer'}">
                  <td class="px-2">
                    <v-icon medium >album</v-icon>
                  </td>
                  <td class="px-2">{{ smallId(item.imageid) }}</td>
                  <td class="px-2">{{ deviceTypeToString(item.type) }}</td>
                  <td class="px-2">{{ prettyList(item.devicemodelsList)  }}</td>
                  <td class="px-2">{{ item.os  }}</td>
                  <td class="px-2">{{ item.plantfolder }}</td>
                  <td class="px-2">{{ item.plantid }}</td>
                  <td class="px-2" v-if='item.status == imageStatus().PENDING'><v-icon small color="info">hourglass_full</v-icon>PENDING</td>
                  <td class="px-2" v-else-if='item.status == imageStatus().RUNNING'><v-icon small color="info">hourglass_full</v-icon>RUNNING</td>
                  <td class="px-2" v-else-if='item.status == imageStatus().DONE'><v-icon small color="success">done</v-icon>DONE</td>
                  <td class="px-2" v-else-if='item.status == imageStatus().FAILED'><v-icon small color="error">error</v-icon>FAILED</td>
                  <td class="px-2" v-else-if='item.status == imageStatus().TIMEOUT'><v-icon small color="error">hourglass_empty</v-icon>TIMEOUT</td>
                  <td class="px-2" >
                    <v-icon small v-if="item.status == imageStatus().DONE && !item.invalid">check</v-icon>
                  </td>
                  <td class="px-2">{{ item.deviceidxsList.length }}</td>
                  <!-- <td>{{ prettyBytes(item.size) }}</td> -->
                  <td class="px-2">{{ item.owner }}</td>
                  <td class="px-2">{{ dateToString(item.lastmodified) }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog"
      persistent
      width="500"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTimeout"
      :top="true"
    >
      {{ snackMessage }}
      <v-btn
        text
        @click="snack = false"
      >
        <div class="v-menu__content--active" style="display:none; z-index:1000;"></div>
        Close
      </v-btn>
    </v-snackbar>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import libvue from '@/lib/vue.js'
import NewImage from '@/components/NewImage.vue'

export default {
  mixins: [libvue],
  data () {
    return {
      search: null,
      dialog: false,
      snack: false,
      snackColor: 'primary',
      snackMessage: '',
      snackTimeout: 1000,
      headers: [
        { text: '', value: '', class:'px-2' },
        { text: 'ID', value: 'imageid' , class:'px-2' },
        { text: 'Type', value: 'type', class:'px-2'  },
        { text: 'Model', value: 'model', class:'px-2'  },
        { text: 'OS', value: 'os', class:'px-2'  },
        { text: 'Plant Folder', value: 'plantfolder', class:'px-2'  },
        { text: 'Plant ID', value: 'plantid' , class:'px-2' },
        { text: 'Status', value: 'status', class:'px-2'  },
        { text: 'Valid', value: 'invalid' , class:'px-2' },
        { text: 'Devices', value: 'deviceidxList' , class:'px-2' },
        //{ text: 'Size', value: 'size' },
        { text: 'Owner', value: 'owner', class:'px-2'  },
        { text: 'Last Modified', value: 'lastmodified' , class:'px-2' }
      ]
    }
  },
  computed: {
    ...mapGetters(['allImages', 'isLoading', 'error']),
  },
  created() {
  },
  watch: {
  },
  components: { NewImage },
  methods: {
    callNewImage() {
      this.dialog = true;
      this.newImage().then((v) => {
        this.dialog = false;
        this.snack = false;
        this.openImageTab(v);
      }).catch((err) => {
        this.dialog = false;
        this.snack = true;
        this.snackColor = 'error'
        this.snackMessage = this.errToString(err);
      });
    },
    openImageTab(imageid) {
      this.$router.push({ name: 'image-details', params: { ImageID: imageid } });
    },
    ...mapActions(['newImage'])
  }
}
</script>
